import { faqs } from "../../data/siteContent";

export const Faq = () => (
  <section className="section faq" id="faq" data-testid="faq-section">
    <div className="section-heading" data-testid="faq-heading">
      <h2 data-testid="faq-title">Questions, answered</h2>
      <p data-testid="faq-subtitle">
        The most common questions leaders, students and professionals ask
        before working with Vartalab.
      </p>
    </div>
    <div className="faq-grid" data-testid="faq-grid">
      {faqs.map((item, index) => (
        <div className="faq-card" key={item.question} data-testid={`faq-${index}`}>
          <h3 data-testid={`faq-${index}-question`}>{item.question}</h3>
          <p data-testid={`faq-${index}-answer`}>{item.answer}</p>
        </div>
      ))}
    </div>
  </section>
);
